import React from 'react';
import { ArchiveProvider } from '../store/archiveContext';
import ArchiveList from '../components/Archive/ArchiveList';

const ArchivePage: React.FC = () => (
    <ArchiveProvider>
        <ArchiveList />
    </ArchiveProvider>
);

export default ArchivePage;
